import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ParticipationHelpComponent} from './participation-help.component';
import {ModalModule} from "ngx-bootstrap/modal";
import {ParticipationHelpModalModule} from "../participation-help-modal/participation-help-modal.module";


@NgModule({
  declarations: [ParticipationHelpComponent],
  imports: [
    CommonModule,
    ModalModule,
    ParticipationHelpModalModule
  ],
  exports: [ParticipationHelpComponent]
})
export class ParticipationHelpModule {
}
